module.exports = __webpack_public_path__ + "img/solution5_03.cc31f102.jpg";